import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import MenuBrowse from "@/pages/customer/MenuBrowse";
import Cart from "@/pages/customer/Cart";
import Checkout from "@/pages/customer/Checkout";
import OrderSuccess from "@/pages/customer/OrderSuccess";

import OwnerLogin from "@/pages/owner/Login";
import Dashboard from "@/pages/owner/Dashboard";
import MenuManagement from "@/pages/owner/MenuManagement";
import OptionGroupsPage from "@/pages/owner/OptionGroupsPage";
import OrdersPage from "@/pages/owner/OrdersPage";
import SettingsPage from "@/pages/owner/SettingsPage";
import ReportsPage from "@/pages/owner/ReportsPage";
import PromosPage from "@/pages/owner/PromosPage";
import CustomersPage from "@/pages/owner/CustomersPage";
import QRCodesPage from "@/pages/owner/QRCodesPage";
import KitchenPage from "@/pages/owner/KitchenPage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Toaster position="top-center" richColors />
            <Routes>
              {/* Customer */}
              <Route path="/" element={<MenuBrowse />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/success/:id" element={<OrderSuccess />} />

              {/* Owner */}
              <Route path="/owner/login" element={<OwnerLogin />} />
              <Route path="/owner" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/owner/menu" element={<ProtectedRoute><MenuManagement /></ProtectedRoute>} />
              <Route path="/owner/options" element={<ProtectedRoute><OptionGroupsPage /></ProtectedRoute>} />
              <Route path="/owner/orders" element={<ProtectedRoute><OrdersPage /></ProtectedRoute>} />
              <Route path="/owner/qr" element={<ProtectedRoute><QRCodesPage /></ProtectedRoute>} />
              <Route path="/owner/kitchen" element={<ProtectedRoute><KitchenPage /></ProtectedRoute>} />
              <Route path="/owner/promos" element={<ProtectedRoute><PromosPage /></ProtectedRoute>} />
              <Route path="/owner/customers" element={<ProtectedRoute><CustomersPage /></ProtectedRoute>} />
              <Route path="/owner/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
              <Route path="/owner/reports" element={<ProtectedRoute><ReportsPage /></ProtectedRoute>} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
